// @import dependencies
import React, { Component, CSSProperties, ReactElement } from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import { SidebarLayout } from 'app_components/modules/sidebar'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import SidebarService from 'app_services/components/sidebar/sidebarService'
// @end

// @import types
// @end

// @ADD Component types
interface ISidebarModuleProps {
  imageNavbarSrc: any
  imageNavbarAlt: string
  app?: any
  className?: string
  style?: CSSProperties
  hideOnClose?: boolean
  extraItems?: ReactElement[]
}
interface ISidebarModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SidebarComponent extends Component<ISidebarModuleProps, ISidebarModuleState> {

  private sidebarService: SidebarService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISidebarModuleProps) {
    super(props)
    this.state = {}

    this.sidebarService = new SidebarService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
   componentDidMount = async () => {}

   /**
    * Evento que se ejecuta cuando el componente es desmontado
    */
   componentWillUnmount = () => {}

   /**
    * Evento que se ejecuta cuando el componente es actualizado
    */
   componentDidUpdate = () => {}

   // @Add custom methods

  render() {
    return (
      <SidebarLayout
        {...this.props}
        menu={this.sidebarService.getSidebarMenuByUser()}
      />
    )
  }
}

export default connect(mapStatesToProps)(SidebarComponent)
